export const sendGoogleEvent = (eventName: string, params?: object) => {
  window.gtag && window.gtag('event', eventName, params);
};
